"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = FormContainer;
exports.FormItem = FormItem;
exports.FormItemDiv = FormItemDiv;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function FormContainer(props) {
  var label = props.label,
    header = props.header,
    vertical = props.vertical,
    collapse = props.collapse,
    classControl = props.classControl;
  var _useState = (0, React.useState)(function () {
      if (typeof props.collapse === 'string') {
        try {
          if (localStorage !== undefined) {
            var _localStorage$getItem;
            var collapses = ((_localStorage$getItem = localStorage.getItem("___unnoForm_collapse")) === null || _localStorage$getItem === void 0 ? void 0 : _localStorage$getItem.split(',').filter(Boolean)) || [];
            return collapses.indexOf(props.collapse) < 0;
          }
        } catch (e) {}
      }
      return !!props.collapse;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var headerCollapseContent = function headerCollapseContent(showBody, check) {
    if (props.headerCollapse && !showBody) {
      var t = _typeof(props.headerCollapse);
      if (check) {
        if (t !== 'boolean') return true;
        if (t === 'boolean' && !!props.header) return true;
        return false;
      } else {
        if (t === 'boolean') return props.header;
        return props.headerCollapse;
      }
    }
    return null;
  };
  var onCollapse = function onCollapse() {
    setOpen(function (prev) {
      if (typeof props.collapse === 'string') {
        try {
          var _localStorage$getItem2;
          var collapses = ((_localStorage$getItem2 = localStorage.getItem("___unnoForm_collapse")) === null || _localStorage$getItem2 === void 0 ? void 0 : _localStorage$getItem2.split(',').filter(Boolean)) || [];
          localStorage.setItem("___unnoForm_collapse", prev ? [].concat(_toConsumableArray(collapses), [props.collapse]).filter(function (v, x, s) {
            return s.indexOf(v) === x;
          }).join(',') : collapses.filter(function (v) {
            return v !== props.collapse;
          }).join(','));
        } catch (e) {}
      }
      return !prev;
    });
  };
  var className = (0, _utils.clsNames)('un-form-container', vertical && '-vertical', props.pb && '-pb', props.className, collapse !== undefined && '-collapse', collapse !== undefined && !open && '-collapse-close');
  var showBody = (0, React.useMemo)(function () {
    return collapse === undefined || open;
  }, [collapse, open]);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-form-header', vertical && '-vertical', !props.m0 && '-margin', props.classHeader)
  }, /*#__PURE__*/React.createElement("div", {
    className: "un-form-label"
  }, collapse !== undefined && /*#__PURE__*/React.createElement(_Icon.default, {
    button: true,
    name: 'chevron-down',
    className: "btn-collapse",
    onClick: onCollapse
  }), typeof label === 'string' ? /*#__PURE__*/React.createElement("div", {
    className: "un-form-title"
  }, label) : label), !!header && showBody && /*#__PURE__*/React.createElement("div", {
    className: "un-form-header-ext"
  }, header)), headerCollapseContent(showBody, true) && /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-form-header-collapse', props.classHeaderCollapse)
  }, headerCollapseContent(showBody, false)), showBody && /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-form-body', props.flex && 'flex', props.grid && 'row', classControl)
  }, props.children));
}
function FormItem(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-form-item', props.labelInput && '-label_input', props.labelInput && '-vcenter', props.flex && '-flex', props.className)
  }, /*#__PURE__*/React.createElement("div", {
    className: '_label'
  }, props.label || ''), /*#__PURE__*/React.createElement("div", {
    className: "_content"
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('_control', props.classControl)
  }, props.row ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, props.children) : props.children), props.note && /*#__PURE__*/React.createElement("div", {
    className: '_note'
  }, props.note)));
}
function FormItemDiv(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-form-item-div', props.className)
  });
}